// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__1NS0Y","focus":"Input_focus__1RFuP","spin":"Input_spin__3B10p","input-gsk":"Input_input-gsk__sYXKb"};